import React from "react";
import LogoBrand from "./LogoBrand";

export default function PrintFrame({ title, subtitle, children, user }) {
  const now = new Date().toLocaleString();
  return (
    <div className="print-container p-6 bg-white">
      <div className="hidden print-only mb-4 border-b border-slate-300 pb-3">
        <div className="flex items-center justify-between">
          <LogoBrand variant="print" />
          <div className="text-right text-[11px] text-slate-500">
            <div>Generated: {now}</div>
            {user && <div>By: {user.name} ({user.role_label || user.role})</div>}
          </div>
        </div>
        <div className="mt-2">
          <div className="font-serif text-xl text-slate-900">{title}</div>
          {subtitle && <div className="text-xs text-slate-500">{subtitle}</div>}
        </div>
      </div>
      {children}
    </div>
  );
}
